import { render } from "./Participants.vue?vue&type=template&id=0ec69ebd&scoped=true"
const script = {}

import "./Participants.vue?vue&type=style&index=0&id=0ec69ebd&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec69ebd"]])

export default __exports__